import type { ConnectivityStateFE, VehicleFE } from 'domain/vehicle';

/**
 * Accepts the domain connectivity string union (`ConnectivityStateFE`), plus `null`/`undefined`.
 */
type ConnectivityStateLike = ConnectivityStateFE | null | undefined;

/**
 * A vehicle is online only when the backend explicitly reports `ONLINE`.
 */
export const isConnectivityOnline = (state: ConnectivityStateLike): boolean => state === 'ONLINE';

/**
 * Everything else (`OFFLINE`, `UNKNOWN`, `null`, `undefined`) is offline.
 */
export const isConnectivityOffline = (state: ConnectivityStateLike): boolean => !isConnectivityOnline(state);

/**
 * Domain-model predicate. `isVehicleOffline(undefined) === true`.
 */
export const isVehicleOffline = (vehicle?: VehicleFE | null): boolean =>
    isConnectivityOffline(vehicle?.connectivity?.value?.value?.state);
